<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `master/center/${inputs.id}` : `master/center`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_week" class="col-sm-3 mb-0">
						Week
					</label>
					<app-input
						id="inputs_week"
						class="col-sm-9"
						type="text"
						v-model="inputs.week"
						placeholder="Week"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.start_date"
						placeholder="Start Date"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_end_date" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_end_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.end_date"
						placeholder="End Date"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_attendance_1" class="col-lg-3">
						星期一
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_1"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_1"
						/>
					</div>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_attendance_2" class="col-lg-3">
						星期二
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_2"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_2"
						/>
					</div>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_attendance_3" class="col-lg-3">
						星期三
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_3"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_3"
						/>
					</div>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_attendance_4" class="col-lg-3">
						星期四
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_4"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_4"
						/>
					</div>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_attendance_5" class="col-lg-3">
						星期五
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_5"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_5"
						/>
					</div>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_attendance_6" class="col-lg-3">
						星期六
					</label>
					<div class="col-lg-9">
						<app-input
							id="inputs_attendance_6"
							type="radio"
							:list="attendanceLists"
							v-model="inputs.attendance_6"
						/>
					</div>
				</div>

			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "StudentAttendanceForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				name: "",
			},
            attendanceLists: [
                { id: 0, value: "A"},
                { id: 1, value: "P"},
            ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
